import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Select,
  MenuItem,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";

//API
import ProcesosApi from "api/procesosApi";

const TIPOS_INMUEBLE = [
  { value: "CASA", label: "Casa" },
  { value: "APARTAMENTO", label: "Apartamento" },
  { value: "LOCAL", label: "Local" },
  { value: "OTRO", label: "Otro" },
];

// const TIPOS_MUEBLE = [
//   { value: "VEHICULO", label: "Vehículo" },
//   { value: "MOTOCICLETA", label: "Motocicleta" },
//   { value: "OTRO", label: "Otro" },
// ];

const EditBien = ({ open, onClose, proceso, bien, onSuccess }) => {
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    tipo_bien: "",
    tipo_inmueble: "",
    direccion: "",
    matricula_inmobiliaria: "",
    tipo_mueble: "",
    placa: "",
    marca: "",
    modelo: "",
    color: "",
    avaluo_catastral: "",
    avaluo_catastralFormatted: "",
    afectaciones: "",
  });

  useEffect(() => {
    if (bien && open) {
      setFormData({
        ...bien,
        avaluo_catastralFormatted: formatCurrency(bien.avaluo_catastral).formatted,
      });
    }
  }, [bien, open]);

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const formatCurrency = (value) => {
    const number = value ? value.replace(/\D/g, "") : "0";
    const numberValue = Number(number);
    const formatter = new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return {
      formatted: formatter.format(number || 0).replace(/\s/g, ""),
      value: numberValue,
    };
  };

  const handleMoneyChange = (field) => (event) => {
    const { formatted, value } = formatCurrency(event.target.value);
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      [`${field}Formatted`]: formatted,
    }));
  };

  const isInmueble = formData.tipo_bien === "INMUEBLE";

  const resetState = () => {
    setError(undefined);
    setFormData({
      tipo_bien: "",
      tipo_inmueble: "",
      direccion: "",
      matricula_inmobiliaria: "",
      tipo_mueble: "",
      placa: "",
      marca: "",
      modelo: "",
      color: "",
      avaluo_catastral: "",
      avaluo_catastralFormatted: "",
      afectaciones: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.tipo_bien === "") {
      setError("Debes seleccionar un Tipo de Bien.");
      return;
    }
    try {
      //console.log("formData: " + JSON.stringify(formData));
      let newBien;
      if (bien) {
        newBien = await ProcesosApi.actualizarBien(proceso.id, bien.id, formData);
      } else {
        newBien = await ProcesosApi.crearBien(proceso.id, formData);
      }
      if (newBien) {
        resetState();
        onSuccess();
      }
    } catch (error) {
      console.error("Error al guardar los datos del Bien:", error);
      setError(obtenerMensajeError(error, "Error al guardar los datos del Bien."));
    }
  };

  const hCClose = () => {
    resetState();
    onClose();
  };

  return (
    <Dialog open={open} onClose={hCClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <SuiTypography variant="h5">
          Editar {isInmueble ? "Bien Inmueble" : "Bien Mueble"}
        </SuiTypography>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Grid>
          </Grid>
          {formData.tipo_bien === "INMUEBLE" ? (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={6}>
                <SuiTypography variant="h6" fontWeight="light">
                  Tipo Inmueble
                </SuiTypography>
                <Select value={formData.tipo_inmueble} onChange={handleChange("tipo_inmueble")}>
                  {TIPOS_INMUEBLE.map((tipo) => (
                    <MenuItem key={tipo.value} value={tipo.value}>
                      {tipo.label}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid size={6}>
                <SuiTypography variant="h6" fontWeight="light">
                  Avalúo Catastral
                </SuiTypography>
                <SuiInput
                  value={formData.avaluo_catastralFormatted}
                  onChange={handleMoneyChange("avaluo_catastral")}
                />
              </Grid>
            </Grid>
          ) : null}
          {formData.tipo_bien === "INMUEBLE" ? (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={6}>
                <SuiTypography variant="h6" fontWeight="light">
                  Dirección
                </SuiTypography>
                <SuiInput value={formData.direccion} onChange={handleChange("direccion")} />
              </Grid>
              <Grid size={6}>
                <SuiTypography variant="h6" fontWeight="light">
                  Matrícula Inmobiliaria
                </SuiTypography>
                <SuiInput
                  value={formData.matricula_inmobiliaria}
                  onChange={handleChange("matricula_inmobiliaria")}
                />
              </Grid>
            </Grid>
          ) : null}
          {formData.tipo_bien === "MUEBLE" ? (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>
                <SuiTypography variant="h6" fontWeight="light">
                  Tipo Mueble
                </SuiTypography>
                <SuiInput value={formData.tipo_mueble} onChange={handleChange("tipo_mueble")} />
                {/* <Select value={formData.tipo_mueble} onChange={handleChange("tipo_mueble")}>
                  {TIPOS_MUEBLE.map((tipo) => (
                    <MenuItem key={tipo.value} value={tipo.value}>
                      {tipo.label}
                    </MenuItem>
                  ))}
                </Select> */}
              </Grid>
              <Grid size={4}>
                <SuiTypography variant="h6" fontWeight="light">
                  Avalúo
                </SuiTypography>
                <SuiInput
                  value={formData.avaluo_catastralFormatted}
                  onChange={handleMoneyChange("avaluo_catastral")}
                />
              </Grid>
              <Grid size={4}>
                <SuiTypography variant="h6" fontWeight="light">
                  Modelo
                </SuiTypography>
                <SuiInput value={formData.modelo} onChange={handleChange("modelo")} />
              </Grid>
            </Grid>
          ) : null}
          {formData.tipo_bien === "MUEBLE" ? (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>
                <SuiTypography variant="h6" fontWeight="light">
                  Marca
                </SuiTypography>
                <SuiInput value={formData.marca} onChange={handleChange("marca")} />
              </Grid>
              <Grid size={4}>
                <SuiTypography variant="h6" fontWeight="light">
                  Placa
                </SuiTypography>
                <SuiInput value={formData.placa} onChange={handleChange("placa")} />
              </Grid>
              <Grid size={4}>
                <SuiTypography variant="h6" fontWeight="light">
                  Color
                </SuiTypography>
                <SuiInput value={formData.color} onChange={handleChange("color")} />
              </Grid>
            </Grid>
          ) : null}
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              <SuiTypography variant="h6" fontWeight="light">
                Afectaciones
              </SuiTypography>
              <SuiInput
                value={formData.afectaciones}
                onChange={handleChange("afectaciones")}
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} buttonColor="light">
            Cancelar
          </SuiButton>
          <SuiButton type="submit" variant="gradient" buttonColor="dark">
            {bien ? "Actualizar" : "Registrar"}
          </SuiButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

EditBien.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  proceso: PropTypes.object,
  bien: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default EditBien;
